import { addMinutes, roundToNearestMinutes } from 'date-fns';

export const isValidDateObject = (date: Date) => {
  return !isNaN(date.valueOf());
}

export const roundToNextHalfHour = (date: Date) => {
  return roundToNearestMinutes(addMinutes(date, 15), { nearestTo: 30 });
};
